<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="text-image-wide p-bottom-xl-1 p-top-xl-1 row-130-25 max">
    <!-- eslint-disable vue/no-v-html -->
    <div class="container max-content">
      <div class="text-section">
        <div class="title title-base" v-html="block.titolo"></div>
        <div class="text text-s-1-b" v-html="block.testo"></div>
      </div>
      <div class="img-container">
        <DefaultPicture
          :image="{
            custom: block.landscape.responsiveImage,
          }"
          :lazy-load="true"
          alt="Istituto Canossiano"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TextImageWide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
